<div id="cdc" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">College Development Council (CDC)</h2>
    <p class="inner-lead mt-3">
      The College Development Council (CDC) is a statutory body that plays an important role in overseeing and guiding
      the development and welfare activities of the college. It promotes academic, infrastructural and holistic growth
      of the institution.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">CDC Document</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/admin/cdc.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/admin/cdc.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download CDC Document
      </a>
    </div>

  </div>
</div>